<template>
    <div>
        <div class="search-top">
            <span>罚单类型</span>
            <el-select class="top-choose" v-model="search.type" clearable>
                <el-option v-for="item in ticketArr" :key="item.id" :value="item.id" :label="item.ticket_name">
                </el-option>
            </el-select>
            <span>时间</span>
            <el-date-picker class="top-choose" v-model="search.start_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.end_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <div class="back-btn blue" @click="searchClick()">查询</div>
        </div>

        <div class="back-list search">
            <div class="list-head">
                <div>罚单编号</div>
                <div>日期</div>
                <div>罚单类型</div>
                <div>罚单金额({{ task_curr.currency_name }})</div>
                <div>处罚原因</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in dataList" :key="item.id">
                    <div>{{ item.code }}</div>
                    <div>{{ item.ticket_date | justDate }}</div>
                    <div>{{ item.category_name }}</div>
                    <div>{{ item.amount }}</div>
                    <div class="overhide" :title="item.remark">{{ item.remark }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchClick"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

    </div>
</template>

<script>
    import { mapState,mapGetters } from 'vuex'

    export default {
        props:['index','buId'],
        data(){
            return {
                search:{
                    type:"",
                    start_date:"",
                    end_date:"",
                },
                ticketArr:[],
                data:{},
            }
        },
        computed:{
            ...mapState(["picker_special"]),
            ...mapGetters(['task_curr']),
            dataList(){
                return this.data.list;
            }
        },
        created(){
            this.$http.get("api/admin/ticket/categorylisttobu").then(res=>{
                if(res.status == 200){
                    this.ticketArr = res.res_data;
                }
            });
            this.fresh(this.index);
        },

        watch:{
            index(val){
                this.fresh(val);
            }
        },

        methods:{
            fresh(index){
                if(index == 5){
                    this.searchClick(this.data.current_page);
                }
            },
            getData(obj={}){
                let url =  `api/admin/bu/ticketlist`;
                obj.bu_id = this.buId;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
            searchClick(page){  //查询
                let obj = {
                    page:page,
                    category:this.search.type,
                    start_date:this.search.start_date,
                    end_date:this.search.end_date,
                }
                this.getData(obj);
            }
        },
    }
</script>

<style lang="less" scoped>

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 15%;
        }
        >div:nth-of-type(2){
            width: 15%;
        }
        >div:nth-of-type(3){
            width: 18%;
        }
        >div:nth-of-type(4){
            width: 18%;
        }
        >div:last-of-type{
            width: 32%;
            padding-right: 2%;
        }
        .add{
            color:#34b96c;
            // color:#43a2ff;
        }
        .reduce{
            color:#ff8383;
        }
    }
</style>





// WEBPACK FOOTER //
// detail-ticket.vue?2cea1bee